import { useState } from "react";
import styles from "./main-app-menu.module.css";
import { DropdownMenu } from "components/common/dropdown-menu";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";
import { ContentAdmin } from "./content-admin";
import { ContentUser } from "./content-user";
import { UIIcon } from "BEDROCK/components/ui-icon-drawing/ui-icon";

export const MainAppMenu = () => {
  const { role, isUserAuthenticated, email } = useAuthContext();
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  return (
    <DropdownMenu
      label={<DropdownLabel />}
      alignment="right"
      isVisible={isDropDownOpen}
      offset={{ x: 0, y: 0 }}
      onToggleVisibility={() => setIsDropDownOpen(!isDropDownOpen)}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          {isUserAuthenticated && (
            <>
              <div className={styles.section}>
                <ContentUser
                  email={email}
                  didClickOption={() => setIsDropDownOpen(false)}
                />
              </div>
              {role === "admin" && (
                <div className={styles.section}>
                  <ContentAdmin
                    didClickOption={() => setIsDropDownOpen(false)}
                  />
                </div>
              )}
            </>
          )}
          <SignInOutUp didClickOption={() => setIsDropDownOpen(false)} />
        </div>
      </div>
    </DropdownMenu>
  );
};

const DropdownLabel = () => {
  return (
    <button className={styles.menuButton} onClick={() => {}}>
      <UIIcon iconName="MAIN-MENU" variant="REGULAR" size={24} />
    </button>
  );
};

interface SignInOutUpProps {
  didClickOption: () => void;
}
const SignInOutUp = (props: SignInOutUpProps) => {
  const { auth, navigateTo } = usePaths();
  const { signOut } = useAuthContext();
  const { isUserAuthenticated } = useAuthContext();

  const handleSignout = () => {
    props.didClickOption();
    signOut();
    navigateTo(auth);
  };

  if (isUserAuthenticated) {
    return (
      <div className={styles.accountControls}>
        <MenuOption
          label="Sign Out"
          iconName="SIGN-OUT"
          onClick={() => {
            handleSignout();
          }}
        />
      </div>
    );
  } else {
    return (
      <div className={styles.accountControls}>
        <MenuOption
          label="Sign in/up"
          iconName="SIGN-IN"
          onClick={() => {
            navigateTo(auth);
            props.didClickOption();
          }}
        />
      </div>
    );
  }
};
